// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__slVGb","right-element":"styles_right-element__0ki3j"};